import { createContext } from 'react';

const COMPANY_CONTEXT_INITIAL_VALUE = {};

export default createContext(COMPANY_CONTEXT_INITIAL_VALUE);
